var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    attrs: { rules: _vm.rules, name: _vm.name, vid: _vm.vid },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ failed, errors }) {
            return [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  style: { "margin-bottom": _vm.marginBottom },
                },
                [
                  _vm.label
                    ? _c(
                        "label",
                        { staticClass: "form-control-label" },
                        [
                          _vm._v(" " + _vm._s(_vm.label) + " "),
                          _vm.explain
                            ? _c("feather", {
                                staticStyle: {
                                  "vertical-align": "bottom",
                                  "margin-left": "10px",
                                  cursor: "pointer",
                                },
                                attrs: { type: "help-circle" },
                                on: { click: _vm.handleExplain },
                              })
                            : _vm._e(),
                          _vm.sublabel
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.sublabel)),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.hideInput
                    ? _c(
                        "div",
                        { staticClass: "input-group input-group-merge" },
                        [
                          _vm.linkstart
                            ? _c(
                                "div",
                                { staticClass: "mr-1 mt-auto mb-auto" },
                                [_vm._v(" " + _vm._s(_vm.linkstart) + " ")]
                              )
                            : _vm.icon
                            ? _c(
                                "div",
                                { staticClass: "input-group-prepend" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-group-text" },
                                    [
                                      _c("feather", {
                                        staticClass: "align-middle icon-dual",
                                        attrs: { type: _vm.icon },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.type === "checkbox" && _vm.type === "number"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.iValue,
                                    expression: "iValue",
                                  },
                                ],
                                ref: "input",
                                staticClass: "form-control",
                                class: { "is-invalid": failed },
                                attrs: {
                                  step: "any",
                                  name: _vm.name,
                                  placeholder: _vm.placeholder,
                                  readonly: _vm.readonly,
                                  disabled: _vm.disabled,
                                  autocomplete: _vm.autocomplete,
                                  accept: _vm.accept,
                                  inputmode: "numeric",
                                  pattern: "[0-9]*",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.iValue)
                                    ? _vm._i(_vm.iValue, null) > -1
                                    : _vm.iValue,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.iValue,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.iValue = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.iValue = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.iValue = $$c
                                      }
                                    },
                                    _vm.handleChanged,
                                  ],
                                },
                              })
                            : _vm.type === "radio" && _vm.type === "number"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.iValue,
                                    expression: "iValue",
                                  },
                                ],
                                ref: "input",
                                staticClass: "form-control",
                                class: { "is-invalid": failed },
                                attrs: {
                                  step: "any",
                                  name: _vm.name,
                                  placeholder: _vm.placeholder,
                                  readonly: _vm.readonly,
                                  disabled: _vm.disabled,
                                  autocomplete: _vm.autocomplete,
                                  accept: _vm.accept,
                                  inputmode: "numeric",
                                  pattern: "[0-9]*",
                                  type: "radio",
                                },
                                domProps: { checked: _vm._q(_vm.iValue, null) },
                                on: {
                                  change: [
                                    function ($event) {
                                      _vm.iValue = null
                                    },
                                    _vm.handleChanged,
                                  ],
                                },
                              })
                            : _vm.type === "number"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.iValue,
                                    expression: "iValue",
                                  },
                                ],
                                ref: "input",
                                staticClass: "form-control",
                                class: { "is-invalid": failed },
                                attrs: {
                                  step: "any",
                                  name: _vm.name,
                                  placeholder: _vm.placeholder,
                                  readonly: _vm.readonly,
                                  disabled: _vm.disabled,
                                  autocomplete: _vm.autocomplete,
                                  accept: _vm.accept,
                                  inputmode: "numeric",
                                  pattern: "[0-9]*",
                                  type: _vm.type,
                                },
                                domProps: { value: _vm.iValue },
                                on: {
                                  change: _vm.handleChanged,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.iValue = $event.target.value
                                  },
                                },
                              })
                            : _vm.type === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.iValue,
                                    expression: "iValue",
                                  },
                                ],
                                ref: "input",
                                staticClass: "form-control",
                                class: { "is-invalid": failed },
                                attrs: {
                                  name: _vm.name,
                                  placeholder: _vm.placeholder,
                                  readonly: _vm.readonly,
                                  disabled: _vm.disabled,
                                  autocomplete: _vm.autocomplete,
                                  accept: _vm.accept,
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.iValue)
                                    ? _vm._i(_vm.iValue, null) > -1
                                    : _vm.iValue,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.iValue,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.iValue = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.iValue = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.iValue = $$c
                                      }
                                    },
                                    _vm.handleChanged,
                                  ],
                                },
                              })
                            : _vm.type === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.iValue,
                                    expression: "iValue",
                                  },
                                ],
                                ref: "input",
                                staticClass: "form-control",
                                class: { "is-invalid": failed },
                                attrs: {
                                  name: _vm.name,
                                  placeholder: _vm.placeholder,
                                  readonly: _vm.readonly,
                                  disabled: _vm.disabled,
                                  autocomplete: _vm.autocomplete,
                                  accept: _vm.accept,
                                  type: "radio",
                                },
                                domProps: { checked: _vm._q(_vm.iValue, null) },
                                on: {
                                  change: [
                                    function ($event) {
                                      _vm.iValue = null
                                    },
                                    _vm.handleChanged,
                                  ],
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.iValue,
                                    expression: "iValue",
                                  },
                                ],
                                ref: "input",
                                staticClass: "form-control",
                                class: { "is-invalid": failed },
                                attrs: {
                                  name: _vm.name,
                                  placeholder: _vm.placeholder,
                                  readonly: _vm.readonly,
                                  disabled: _vm.disabled,
                                  autocomplete: _vm.autocomplete,
                                  accept: _vm.accept,
                                  type: _vm.type,
                                },
                                domProps: { value: _vm.iValue },
                                on: {
                                  change: _vm.handleChanged,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.iValue = $event.target.value
                                  },
                                },
                              }),
                          _vm.showLabelButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-outline-primary",
                                  staticStyle: {
                                    "margin-left": "10px",
                                    float: "right",
                                    "min-width": "39px",
                                  },
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.buttonDisabled,
                                  },
                                  on: { click: _vm.labelButtonClick },
                                },
                                [
                                  _vm.buttonLoading
                                    ? _c("b-spinner", {
                                        staticClass: "align-middle",
                                        staticStyle: {
                                          width: "20px",
                                          height: "20px",
                                        },
                                        attrs: { size: "xs" },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " + _vm._s(_vm.labelButtonText) + " "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._t("default"),
                          errors.length
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  style: { marginLeft: _vm.icon ? "48px" : "" },
                                },
                                [_vm._v(" " + _vm._s(errors[0]) + " ")]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.help
                    ? _c("span", { staticClass: "help-block" }, [
                        _c("small", {
                          domProps: { innerHTML: _vm._s(_vm.help) },
                        }),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }